// extracted by mini-css-extract-plugin
module.exports = {"cart":"styles_cart__35a55","cart__header":"styles_cart__header__3kGcI","cart__close-and-lang-dropdown":"styles_cart__close-and-lang-dropdown__3mBu6"};